module.exports = __webpack_public_path__ + "img/chinesecompany266.ae86482e.png";